import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Descriptions, Drawer, Flex, Table } from 'antd';
import React, { useState } from 'react';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { useSelector } from 'react-redux';
import {
  addPurchaseReciept,
  getMapReferencePR,
} from '../../../network/purchaseReciept';
import dayjs from 'dayjs';

const DetailsPurchaseReturn = ({ open, setOpen, IdReturn, t }) => {
  const client = useQueryClient();
  const [loadingAdd, setLoadingAdd] = useState(false);
  const { message } = App.useApp();
  const { currentLang } = useSelector((state) => state.user);
  const { mutate: onAddPurchaseReciept } = useMutation({
    mutationKey: ['addPurchaseReciept'],
    mutationFn: (name) => addPurchaseReciept(name),
    onSuccess: (data) => {
      setLoadingAdd(false);
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      message.success('Order returned successfully!');
      client.invalidateQueries({
        queryKey: [queryKeys.getPurchaseReciept],
      });
      setOpen(false);
    },
    onError: (error) => {
      setLoadingAdd(false);
      message.error(error.response.data.exception);
      console.log('error:', error);
    },
  });

  const { data: returnData, isLoading: loadingReturn } = useQuery({
    queryKey: [queryKeys.getMapReferencePR, IdReturn],
    queryFn: () => getMapReferencePR(IdReturn),
    keepPreviousData: true,
    enabled: !!IdReturn,
  });
  const {
    buying_price_list,
    company_trn,
    conversion_rate,
    currency,
    discount_amount,
    grand_total,
    in_words,
    ignore_pricing_rule,
    is_return,
    is_subcontracted,
    items,
    posting_date,
    posting_time,
    price_list_currency,
    rounded_total,
    rounding_adjustment,
    supplier_name,
    // supplier_name_in_arabic,
    taxes,
    total,
  } = returnData?.message || {};
  const itemsDescriptions = [
    {
      key: '1',
      label: t.Supplier,
      children: supplier_name,
    },
    // {
    //   key: '2',
    //   label: t.SupplierNameInArabic,
    //   children: supplier_name_in_arabic,
    // },
    {
      key: '3',
      label: t.postingDate,
      children: dayjs(posting_date).format('YYYY-MM-DD'),
    },
    {
      key: '4',
      label: t.postingTime,
      children: dayjs(posting_time).format('HH:mm:ss'),
    },
    {
      key: '5',
      label: t.buyingPriceList,
      children: buying_price_list,
    },
    {
      key: '6',
      label: t.priceListCurrency,
      children: price_list_currency,
    },
    {
      key: '7',
      label: t.companyTrn,
      children: company_trn,
    },
    {
      key: '8',
      label: t.currency,
      children: currency,
    },
    {
      key: '9',
      label: t.isReturn,
      children: is_return ? t.Yes : t.No,
    },
    {
      key: '10',
      label: t.isSubcontracted,
      children: is_subcontracted ? t.Yes : t.No,
    },
    {
      key: '11',
      label: t.ignorePricingRule,
      children: ignore_pricing_rule ? t.Yes : t.No,
    },
    {
      key: '12',
      label: t.Total,
      children: total,
    },
    {
      key: '13',
      label: t.inWords,
      children: in_words,
    },
    {
      key: '14',
      label: t.grandTotal,
      children: grand_total,
    },
    {
      key: '15',
      label: t.roundedTotal,
      children: rounded_total,
    },
    {
      key: '16',
      label: t.roundingAdjustment,
      children: rounding_adjustment,
    },
    {
      key: '17',
      label: t.discountAmount,
      children: discount_amount,
    },
    {
      key: '18',
      label: t.conversionRate,
      children: conversion_rate,
    },
    {
      key: '19',
      label: t.items,
      span: 24,
      children: (
        <Table
          className="table_custom"
          columns={[
            // {
            //   title: t.materialRequest,
            //   dataIndex:"material_request",
            //   key: '1',
            // },
            // {
            //   title: t.purchaseOrder,
            //   dataIndex:"purchase_order",
            //   key: '2',
            // },
            {
              title: t.itemName,
              dataIndex: 'item_name',
              key: '3',
            },
            {
              title: t.itemGroup,
              dataIndex: 'item_group',
              key: '4',
            },
            {
              title: t.costCenter,
              dataIndex: 'cost_center',
              key: '5',
            },
            {
              title: t.itemTaxTemplate,
              dataIndex: 'item_tax_template',
              key: '6',
            },
            {
              title: t.priceListRate,
              dataIndex: 'price_list_rate',
              key: '7',
            },
            {
              title: t.rate,
              dataIndex: 'rate',
              key: '8',
            },
            {
              title: t.qty,
              dataIndex: 'qty',
              key: '9',
            },
            {
              title: t.amount,
              dataIndex: 'amount',
              key: '10',
            },
            {
              title: t.scheduleDate,
              dataIndex: 'schedule_date',
              key: '11',
            },
          ]}
          dataSource={items}
          pagination={false}
          // size="small"
          scroll={{ x: 'max-content' }}
          // className="table"
          // bordered
        />
      ),
    },

    {
      key: '20',
      label: t.taxes,
      span: 24,
      children: (
        <Table
          className="table_custom"
          columns={[
            {
              title: t.Category,
              dataIndex: 'category',
              key: '3',
            },
            {
              title: t.addDeductTax,
              dataIndex: 'add_deduct_tax',
              key: '4',
            },
            {
              title: t.chargeType,
              dataIndex: 'charge_type',
              key: '5',
            },
            {
              title: t.description,
              dataIndex: 'description',
              key: '6',
            },
            {
              title: t.accountHead,
              dataIndex: 'account_head',
              key: '7',
            },
            {
              title: t.costCenter,
              dataIndex: 'cost_center',
              key: '8',
            },
            {
              title: t.includedInPaidAmount,
              dataIndex: 'included_in_paid_amount',
              key: '9',
            },
            {
              title: t.includedInPrintRate,
              dataIndex: 'included_in_print_rate',
              key: '10',
            },
            {
              title: t.Rate,
              dataIndex: 'rate',
              key: '11',
            },
            {
              title: t.Total,
              dataIndex: 'total',
              key: '12',
            },
          ]}
          dataSource={taxes}
          pagination={false}
          scroll={{ x: 'max-content' }}
          // className="table"
        />
      ),
    },
  ];
  return (
    <>
      <Drawer
        closable
        destroyOnClose
        title={<p>{t.purchaseReturn + ': ' + IdReturn}</p>}
        placement={currentLang === 'en' ? 'right' : 'left'}
        footer={
          <Flex gap={10} justify="end">
            <Button
              type="primary"
              ghost
              onClick={() => {
                setOpen(false);
              }}
            >
              {t.cancel}
            </Button>
            <Button
              type="primary"
              // ghost
              loading={loadingAdd}
              onClick={() => {
                setLoadingAdd(true);
                onAddPurchaseReciept({
                  ...returnData?.message,
                });
              }}
            >
              {t.submit}
            </Button>
          </Flex>
        }
        open={open}
        loading={loadingReturn}
        onClose={() => setOpen(false)}
        width={'70%'}
      >
        <Descriptions
          title={t.RecieptDetails}
          layout="vertical"
          items={itemsDescriptions}
        />
      </Drawer>
    </>
  );
};

export default DetailsPurchaseReturn;
